<mat-toolbar class="toolbar-sm">
    <img src="app/assets/images/expand-rows-down.png" width="16" height="16" id="expandRowsDown"
        matTooltip="{{engLang ? 'Expand All Claims' : 'Expandir todos los casos'}}" matTooltipPosition="above"
        (click)="onClick_menu($event)" style="cursor: pointer;">

    <img src="app/assets/images/collapse-rows-up.png" width="16" height="16" id="collapseRowsUp"
        matTooltip="{{engLang ? 'Collapse All Claims' : 'Colapsar todos los casos'}}" matTooltipPosition="above"
        (click)="onClick_menu($event)" style="cursor: pointer;">

    <i class="fa fa-trash font12" id="delete" matTooltip="{{ engLang ? 'Delete Report': 'Eliminar Reporte' }}"
        matTooltipPosition="above" (click)=" onClick_menu($event)" style="cursor: pointer;"></i>

    <i class="far fa-file-excel font13" matTooltipPosition="above" id="exportToExcel" matTooltip="Excel"
        (click)="onClick_menu($event)" style="cursor: pointer;"></i>

    <mat-icon class="font15 pt-1" matTooltip="{{engLang ? 'Print' : 'Imprimir'}}" matTooltipPosition="above"
        (click)="insPrintAllInsOnly=true; printRpt(undefined,false)" id="print"
        style="cursor: pointer; font-size: 1rem;">print</mat-icon>
</mat-toolbar>

<mat-form-field style="height: 75px; min-height: 75px; width: 100%;">
    <mat-label class="font13">{{engLang ? 'Select from past reports' : 'Seleccione de reportes
        pasados'}}</mat-label>
    <mat-select (selectionChange)="onChange_view($event.value)" class="text-center" style="font-size: 14px;">
        <mat-option *ngFor="let v of rptEspCobData().views" [value]="v.name">
            <span style="font-size: 13px;">{{engEspCobDescr(v.name)}}</span>
        </mat-option>
    </mat-select>
</mat-form-field>

<div class="mat-table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortea($event)" class="mat-elevation-z8"
        multiTemplateDataRows [matSortDisableClear]="true" matSortActive="InLNm" matSortDirection="asc">

        <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

        <!-- Alternative hack to cause clm() to propagate changes to dataSource -->
        <!-- <div *ngIf="clm().length >= 0"></div> -->

        <!-- <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center font12"> Number </th>
            <td mat-cell *matCellDef="let ins" class="font10">
                {{clm.index}} </td>
        </ng-container> -->

        <ng-container matColumnDef="InLNm">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center font12">Plan</th>
            <td mat-cell *matCellDef="let ins" class="font10 ellipsis" appTooltipIfCollapsed [matTooltip]="ins.InLNm">
                {{ins.InLNm}}
            </td>
            <td mat-footer-cell *matFooterCellDef="let tot"> {{rptEspCobData().tot.InLNm}} </td>
        </ng-container>

        <ng-container matColumnDef="InID">
            <th mat-header-cell *matHeaderCellDef class="font12"
                matTooltip="{{engLang ? 'Internal plan ID':'ID interno del plan'}}" matTooltipPosition="above">ID</th>
            <td mat-cell *matCellDef="let ins" class="font10">
                {{ins.InID}}
            </td>
            <td mat-footer-cell *matFooterCellDef="let tot"></td>
        </ng-container>

        <ng-container matColumnDef="Usual">
            <th mat-header-cell *matHeaderCellDef class="rtalign font12">Usual</th>
            <td mat-cell *matCellDef="let ins" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(ins.Usual) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(ins.Usual) | currency:'USD':'':'0.2-2'}}
            </td>
            <td mat-footer-cell *matFooterCellDef="let tot" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(rptEspCobData().tot.Usual) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(rptEspCobData().tot.Usual) | currency:'USD':'':'0.2-2'}}
            </td>
        </ng-container>

        <ng-container matColumnDef="Xpected">
            <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="rtalign font12"
                matTooltip="{{engLang ? 'Expected or tariff':'Esperado o tarifa'}}" matTooltipPosition="above">
                {{engLang ? 'Expect' : 'Espera'}}
            </th>
            <td mat-cell *matCellDef="let ins" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(ins.Xpected) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(ins.Xpected) | currency:'USD':'':'0.2-2'}}
            </td>
            <td mat-footer-cell *matFooterCellDef="let tot" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(rptEspCobData().tot.Xpected) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(rptEspCobData().tot.Xpected) | currency:'USD':'':'0.2-2'}}</td>
        </ng-container>

        <ng-container matColumnDef="AdjPos">
            <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="rtalign font12"
                matTooltip="{{engLang ? 'Positive adjustments':'Ajustes positivos'}}" matTooltipPosition="above">
                Adjust+ </th>
            <td mat-cell *matCellDef="let ins" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(ins.AdjPos) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(ins.AdjPos) | currency:'USD':'':'0.2-2'}} </td>
            <td mat-footer-cell *matFooterCellDef="let tot" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(rptEspCobData().tot.AdjPos) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(rptEspCobData().tot.AdjPos) | currency:'USD':'':'0.2-2'}}</td>
        </ng-container>

        <ng-container matColumnDef="Payed">
            <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="rtalign font12"
                matTooltip="{{engLang ? 'Payed by plan':'Pagado por el plan'}}" matTooltipPosition="above"> {{engLang ?
                'Plan Pay': 'Pago Plan'}} </th>
            <td mat-cell *matCellDef="let ins" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(ins.Payed) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(ins.Payed) | currency:'USD':'':'0.2-2'}} </td>
            <td mat-footer-cell *matFooterCellDef="let tot" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(rptEspCobData().tot.Payed) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(rptEspCobData().tot.Payed) | currency:'USD':'':'0.2-2'}}</td>
        </ng-container>

        <ng-container matColumnDef="AdjNeg">
            <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="rtalign font12"
                matTooltip="{{engLang ? 'Negative adjustments':'Ajustes negativos'}}" matTooltipPosition="above">
                Adjust- </th>
            <td mat-cell *matCellDef="let ins" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(ins.AdjNeg) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(ins.AdjNeg) | currency:'USD':'':'0.2-2'}} </td>
            <td mat-footer-cell *matFooterCellDef="let tot" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(rptEspCobData().tot.AdjNeg) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(rptEspCobData().tot.AdjNeg) | currency:'USD':'':'0.2-2'}}</td>
        </ng-container>

        <ng-container matColumnDef="IBal">
            <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="rtalign font12"
                matTooltip="{{engLang ? 'Plan balance':'Balance del plan'}}" matTooltipPosition="above">Balance</th>
            <td mat-cell *matCellDef="let ins" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(ins.IBal) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(ins.IBal) | currency:'USD':'':'0.2-2'}} </td>
            <td mat-footer-cell *matFooterCellDef="let tot" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(rptEspCobData().tot.IBal) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(rptEspCobData().tot.IBal) | currency:'USD':'':'0.2-2'}}</td>
        </ng-container>

        <ng-container matColumnDef="Pvdo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="rtalign font12"
                matTooltip="{{engLang ? 'Patient responsibility':'Responsabilidad del paciente'}}"
                matTooltipPosition="above"> {{engLang ? 'Pat Resp':
                'Privado'}} </th>
            <td mat-cell *matCellDef="let ins" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(ins.Pvdo) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(ins.Pvdo) | currency:'USD':'':'0.2-2'}}
            </td>
            <td mat-footer-cell *matFooterCellDef="let tot" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(rptEspCobData().tot.Pvdo) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(rptEspCobData().tot.Pvdo) | currency:'USD':'':'0.2-2'}}</td>
        </ng-container>

        <ng-container matColumnDef="PPayed">
            <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="rtalign font12"
                matTooltip="{{engLang ? 'Payd by patient':'Pagado por el paciente'}}" matTooltipPosition="above">
                <span>{{engLang ? 'Pat Pay': 'Pago Pvdo'}}</span>
            </th>
            <td mat-cell *matCellDef="let ins" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(ins.PPayed) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(ins.PPayed) | currency:'USD':'':'0.2-2'}} </td>
            <td mat-footer-cell *matFooterCellDef="let tot" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(rptEspCobData().tot.PPayed) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(rptEspCobData().tot.PPayed) | currency:'USD':'':'0.2-2'}}</td>
        </ng-container>

        <ng-container matColumnDef="PDisc">
            <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="rtalign font12"
                matTooltip="{{engLang ? 'Patient discount':'Descuento al paciente'}}" matTooltipPosition="above">
                {{engLang ? 'Disc': 'Desc'}} </th>
            <td mat-cell *matCellDef="let ins" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(ins.PDisc) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(ins.PDisc) | currency:'USD':'':'0.2-2'}} </td>
            <td mat-footer-cell *matFooterCellDef="let tot" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(rptEspCobData().tot.PDisc) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(rptEspCobData().tot.PDisc) | currency:'USD':'':'0.2-2'}}</td>
        </ng-container>

        <ng-container matColumnDef="PBal">
            <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before" class="rtalign font12"
                matTooltip="{{engLang ? 'Patient balance':'Balance del paciente'}}" matTooltipPosition="above">{{engLang
                ? 'Pat Bal': 'Bal Pvdo'}}</th>
            <td mat-cell *matCellDef="let ins" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(ins.PBal) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(ins.PBal) | currency:'USD':'':'0.2-2'}} </td>
            <td mat-footer-cell *matFooterCellDef="let tot" class="rtalign font10 ellipsis" appTooltipIfCollapsed
                [matTooltip]="_recordService.makeNum(rptEspCobData().tot.PBal) | currency:'USD':'':'0.2-2'">
                {{_recordService.makeNum(rptEspCobData().tot.PBal) | currency:'USD':'':'0.2-2'}}</td>
        </ng-container>

        <ng-container matColumnDef="Cnt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="rtalign font12">{{engLang ? 'Invoices':
                'Facturas'}}</th>
            <td mat-cell *matCellDef="let ins" class="rtalign font10">
                {{ins.Cnt | currency:'USD':'':'0.0'}} </td>
            <td mat-footer-cell *matFooterCellDef="let tot" class="rtalign font10 ellipsis">{{rptEspCobData().tot.Cnt |
                currency:'USD':'':'0.0'}}</td>
        </ng-container>

        <ng-container matColumnDef="printr">
            <th mat-header-cell *matHeaderCellDef>
                <div *ngIf="!insPrintAll" class="d-flex justify-content-between" style="height:100%;">
                    <div style="margin-top: .75rem;">
                        <mat-icon class="maticon" style="cursor: pointer; font-size: 1rem;"
                            (click)="insPrintAll=true; printRpt(undefined,false)">print</mat-icon>
                    </div>
                    <div>&nbsp;&nbsp;</div>
                    <div style="margin-top: .625rem; cursor: pointer;">
                        <i class="far fa-file-excel" (click)="insPrintAll=true; printRpt(undefined,true)"></i>
                    </div>
                </div>
                <img src="/app/assets/images/waiting4Response.gif" width="20" height="20" alt="spinner"
                    class="img-fluid" *ngIf="insPrintAll">
            </th>
            <td mat-cell *matCellDef="let ins">
                <div *ngIf="!clm.printing" class="d-flex justify-content-between" style="height:100%;">
                    <div>
                        <mat-icon *ngIf="!ins.printing" class="maticon"
                            style="cursor: pointer; font-size: 1rem;margin-top: .75rem;"
                            (click)="ins.printing=true; printRpt(ins,false)">print</mat-icon>
                        <img src="/app/assets/images/waiting4Response.gif" width="30" height="30" alt="spinner"
                            class="img-fluid" style="font-size: 1rem;margin-top: .75rem;" *ngIf="ins.printing">
                    </div>
                    <div>&nbsp;&nbsp;</div>
                    <div style="margin-top: .625rem; cursor: pointer;">
                        <i class="far fa-file-excel" (click)="ins.printing=true; printRpt(ins,true)"></i>
                    </div>
                </div>
            </td>
            <td mat-footer-cell *matFooterCellDef="let ins"></td>
        </ng-container>

        <ng-container matColumnDef="expandClms"> <!-- Expand Claims Column -->
            <td mat-cell *matCellDef="let row" [attr.colspan]="rptEspCobDisplydCols.length">
                <div style="display: flex; justify-content: space-between;">
                    <div></div>
                    <div class="vt-shell">

                        <!-- Static header OUTSIDE the viewport (shown once) -->
                        <div id="vtHeaderEl" class="vt-grid vt-header vt-row vt-sticky font10" style="width: 100%;">
                            <div [innerHTML]="engLang ? 'Claim&nbsp;No.' : 'Caso&nbsp;No.'">
                            </div>
                            <div [innerHTML]="'Loc'">
                            </div>
                            <div class="vt-cell--center"
                                [matTooltip]="engLang ? 'Primary (1) or secondary (2) plan' : 'Plan primario (1) o secundario (2)'"
                                matTooltipPosition="right">PS
                            </div>
                            <div class="vt-cell--truncate">{{ engLang ? 'Patient' :
                                'Paciente'}}
                            </div>
                            <div class="vt-cell--right">{{ engLang ? 'Usual' :
                                'Usual' }}
                            </div>
                            <div class="vt-cell--right">{{ engLang ? 'Expected':
                                'Esperado'
                                }}
                            </div>
                            <div class="vt-cell--right">{{ engLang ? 'Payed' :
                                'Pagado' }}
                            </div>
                            <div class="vt-cell--right">Balance</div>
                            <div class="vt-cell--right">Bal&nbsp;P</div>
                            <div>{{ engLang ? 'Date' :
                                'Fecha' }}
                            </div>
                            <div class="vt-cell--center" [matTooltip]="engLang ? 'Claim adjusted' : 'Caso ajustado'"
                                matTooltipPosition="left">Adj</div>
                            <div class="vt-cell--center" [matTooltip]="engLang ? 'Claim reclaimed' : 'Caso reclamado'"
                                matTooltipPosition="left">Recl</div>
                        </div>

                        <cdk-virtual-scroll-viewport *ngIf="isExpanded(row)" class="vt-viewport font10"
                            [itemSize]="ROW_SIZE" [style.height.px]="(+expandedCounts?.get(row.InID.toString()) ?? 0) * ROW_SIZE > maxVpHeight ? maxVpHeight :
                            (+expandedCounts?.get(row.InID.toString()) ?? 0) * ROW_SIZE" style="width: 100%;"
                            (scrolledIndexChange)="syncHeaderPad(vp)" #vp>

                            <!-- Flattened items for this parent row -->
                            <ng-container
                                *cdkVirtualFor="let item of getExpandedItems(row); let i = index; trackBy: trackExpanded">
                                <!-- Simple switch for item kind -->
                                <div class="expanded-row" [ngClass]="item.kind">
                                    <ng-container [ngSwitch]="item.kind">
                                        <div *ngSwitchCase="'clm'">

                                            <div class="vt-grid vt-row font10" [class.vt-row--clm-bg]="hoverIndex !== i"
                                                [class.vt-row--clm-hover]="hoverIndex === i"
                                                (mouseenter)="onRowHover(item, i, true)"
                                                (mouseleave)="onRowHover(item, i, false)">
                                                <button mat-button class="link-button font12"
                                                    (click)="openRecordCaseModal(item.c.patNm, item.c.CasNo + '-' + item.c.CasOfNo, engLang, item.c.CasPatID, item.c.CasID)">
                                                    {{ item.c.CasNo }}
                                                </button>
                                                <div>{{ item.c.CasOfNo }}</div>
                                                <div class="vt-cell--center">{{
                                                    item.c.ps }}</div>
                                                <div class="vt-cell--truncate" [matTooltip]="item.c.patNm"
                                                    matTooltipPosition="right">{{
                                                    item.c.patNm
                                                    }}
                                                </div>
                                                <div class="vt-cell--num">{{
                                                    item.c.casUsual
                                                    |
                                                    currency:'USD':'':'0.2-2' }}
                                                </div>
                                                <div class="vt-cell--num">{{
                                                    item.c.casXpect
                                                    |
                                                    currency:'USD':'':'0.2-2' }}
                                                </div>
                                                <div class="vt-cell--num">{{
                                                    item.c.casIPayed |
                                                    currency:'USD':'':'0.2-2' }}
                                                </div>
                                                <div class="vt-cell--num">{{
                                                    item.c.casBalance |
                                                    currency:'USD':'':'0.2-2' }}
                                                </div>
                                                <div class="vt-cell--num">{{
                                                    item.c.casBPvdo
                                                    |
                                                    currency:'USD':'':'0.2-2' }}
                                                </div>
                                                <div>{{
                                                    item.c.casDt
                                                    }}
                                                </div>
                                                <div class="chk" [class.chk--on]="item.c.adjusted == 1"></div>
                                                <div class="chk" [class.chk--on]="item.c.reclaimed == 1"></div>
                                                <div>
                                                    &nbsp; <!-- Internal right margin -->
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngSwitchCase="'det'">
                                            <div *ngIf="item.d.index == '0'" class="vt-grid-det-heads vt-row-det font9">
                                                <div>CPT</div>
                                                <!-- <div>PS</div> -->
                                                <div>{{engLang ? 'Qty' : 'Cant'}}</div>
                                                <div>{{engLang ? 'From' : 'Desde'}}</div>
                                                <div>{{engLang ? 'To' : 'Hasta'}}</div>
                                                <div class="vt-cell--center"
                                                    [matTooltip]="engLang ? 'Place of Service' : 'Lugar del servicio'"
                                                    matTooltipPosition="right">POS</div>
                                                <div class="vt-cell--right">{{engLang ? 'Usual' : 'Usual'}}</div>
                                                <div class="vt-cell--right">{{engLang ? 'Expected' : 'Esperado'}}</div>
                                                <div class="vt-cell--right">{{engLang ? 'Pat Resp' : 'Privado'}}</div>
                                                <div class="vt-cell--truncate">{{engLang ? 'Rendering' : 'Productor'}}
                                                </div>
                                                <div class="vt-cell--truncate">{{engLang ? 'Description' :
                                                    'Descripción'}}</div>
                                            </div>
                                            <div class="vt-grid-det-cols vt-row font10"
                                                [class.vt-row--det-bg]="hoverIndex !== i"
                                                [class.vt-row--det-hover]="hoverIndex === i"
                                                (mouseenter)="onRowHover(item, i, true)"
                                                (mouseleave)="onRowHover(item, i, false)">
                                                <div>{{item.d.pcode}}</div>
                                                <!-- <div>{{item.d.ps}}</div> -->
                                                <div class="vt-cell--center">{{item.d.qty}}</div>
                                                <div>{{item.d.detFromDt}}</div>
                                                <div>{{item.d.detToDt}}</div>
                                                <div>{{item.d.pos}}</div>
                                                <div class="vt-cell--num">{{item.d.usual}}</div>
                                                <div class="vt-cell--num">{{item.d.xpect}}</div>
                                                <div class="vt-cell--num">{{item.d.privado}}</div>
                                                <div class="vt-cell--truncate" [matTooltip]="item.d.productor"
                                                    matTooltipPosition="left" matTooltipShowDelay="300">
                                                    {{item.d.productor}}</div>
                                                <div class="vt-cell--truncate" [matTooltip]="item.d.descr"
                                                    matTooltipPosition="left" matTooltipShowDelay="300">
                                                    {{item.d.descr}}</div>
                                            </div>
                                        </div>

                                        <div *ngSwitchCase="'pay'">
                                            <div *ngIf="item.p.index == '0'" class="vt-grid-pay-heads vt-row-pay font9">
                                                <div [matTooltip]="engLang ? 'Pay source' : 'Fuente de Pago'"
                                                    matTooltipPosition="right" matTooltipShowDelay="300">FP</div>
                                                <div>{{engLang ? 'Date' : 'Fecha'}}</div>
                                                <div class="vt-cell--right">{{engLang ? 'Payed' : 'Pagado'}}</div>
                                                <div>Ck No.</div>
                                                <div>{{engLang ? 'Mode' : 'Modo'}}</div>
                                                <div class="vt-cell--truncate"
                                                    [matTooltip]="'Internal Control No (from plan)'"
                                                    matTooltipPosition="right" matTooltipShowDelay="300">ICN</div>
                                                <div class="vt-cell--truncate">{{engLang ? 'Notes' : 'Notas'}}</div>
                                            </div>
                                            <div class="vt-grid-pay-cols vt-row vt-row--pay font10"
                                                [class.vt-row--pay-bg]="hoverIndex !== i"
                                                [class.vt-row--pay-hover]="hoverIndex === i"
                                                (mouseenter)="onRowHover(item, i, true)"
                                                (mouseleave)="onRowHover(item, i, false)">
                                                <div>{{item.p.payPS}}</div>
                                                <div>{{item.p.payedDt}}</div>
                                                <div class="vt-cell--num">{{item.p.payAmnt}}</div>
                                                <div class="vt-cell--truncate-start" [matTooltip]="item.p.payCkNo"
                                                    matTooltipPosition="right" matTooltipShowDelay="300">
                                                    {{item.p.payCkNo}}</div>
                                                <div>{{item.p.payMode}}</div>
                                                <div class="vt-cell--truncate" [matTooltip]="item.p.payApCode"
                                                    matTooltipPosition="right" matTooltipShowDelay="300">
                                                    {{item.p.payApCode}}</div>
                                                <div class="vt-cell--truncate" [matTooltip]="item.p.payNotes"
                                                    matTooltipPosition="right" matTooltipShowDelay="300">
                                                    {{item.p.payNotes}}</div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                            <!-- {{(+expandedCounts?.get(row.InID.toString()) ?? 0)}} -->
                        </cdk-virtual-scroll-viewport>
                    </div>
                    <div></div>
                </div>
            </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="rptEspCobDisplydCols; sticky: true" class="ins-header-row"></tr>
        <tr mat-row *matRowDef="let row; columns: rptEspCobDisplydCols;" class="ins-row"
            [ngClass]="row.index % 2 === 0 ? 'ins-even-row' : 'ins-odd-row'" (click)="onClick_expandIns(row,$event)">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandClms'];"
            [ngStyle]="{'display': (isExpanded(row) ? '' : 'none')}"
            [ngClass]="row.index % 2 === 0 ? 'clm-even-row' : 'clm-odd-row'">
        </tr>
        <tr mat-footer-row *matFooterRowDef="rptEspCobDisplydCols" class="ins-footer font12"></tr>
    </table>
</div>